// 费用信息查询
<template>
    <div class="fullPage">
        <img src="../../../assets/image/banner/banner3.jpg" alt class="fullWidth"/>
        <div class="main-center main-top">
            <!--费用信息查询-->
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('confirmFreight.title')" class="searchComposite">
                    <div>
                        <div class="flex flex-space-around">
                            <!--船名/航次-->
                            <div class="inputName">
                                <el-col :span="7" style="width: 33%">
                                    <span class="inputName-title" style="width: 30%">{{$t("confirmFreight.vvl")}}</span>
                                    <el-input v-model="vesselCode" :placeholder="$t('common.pleaseSelect')"/>
                                </el-col>
                                <el-col :span="7" style="width: 31%">
                                    <el-input v-model="voyageNo" :placeholder="$t('common.pleaseSelect')"/>
                                </el-col>
                                <el-col :span="5" style="width: 21%">
                                    <el-input v-model="voyageLeg" :placeholder="$t('common.pleaseSelect')"/>
                                </el-col>
                                <el-col :span="3" style="width: 10%">
                                    <!--VVL弹框-->
                                    <el-popover ref="popover" placement="bottom" width="700" trigger="click"
                                                @hide="boatListShow=false">
                                        <div>
                                            <div class="flex flex-space-between">
                                                <!--船名查询条件-->
                                                <div class="inputName-left boatBox">
                                                    <div class="inputName-title-left">
                                                        <span>{{$t('booking.popover.vessel')}}</span>
                                                    </div>
                                                    <el-input v-model="vesselCode"
                                                              :placeholder="$t('common.pleaseEnter')" clearable
                                                              @focus="showVesselList">
                                                        <img src="../../../assets/image/icon/classification.svg"
                                                             slot="suffix"
                                                             @click="showVesselList">
                                                    </el-input>
                                                    <!--船名列表-->
                                                    <div class="boatBox-list-box" v-show="boatListShow">
                                                        <div class="boatBox-top flex">
                                                            <div class="left">
                                                                {{$t('booking.popover.vesselCode')}}
                                                            </div>
                                                            <div class="right">
                                                                {{$t('booking.popover.vesselNameCn')}}
                                                            </div>
                                                        </div>
                                                        <ul>
                                                            <li v-for="(i,j) in boatList" class="flex"
                                                                :key="j"
                                                                @click="checkBoatData(i)">
                                                                <div class="left">{{i.vesselCode}}</div>
                                                                <div class="right">{{i.vesselNameCn}}</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="inputName-left">
                                                    <div class="inputName-title-left">
                                                        <span>{{$t('booking.popover.vesselNameCn')}}</span>
                                                    </div>
                                                    <el-input v-model="vesselName"
                                                              :placeholder="$t('common.pleaseEnter')"
                                                              clearable/>
                                                </div>
                                                <!--VVL查询按钮-->
                                                <el-button class="popoverInner" size="small" icon="el-icon-search"
                                                           @click="vvlPopoverSearch">
                                                    {{findButton}}
                                                </el-button>
                                            </div>
                                            <div class="flex flex-space-between">
                                                <!--航次查询条件-->
                                                <div class="inputName-left">
                                                    <div class="inputName-title-left">
                                                        <span>{{$t('booking.popover.voyageNo')}}</span>
                                                    </div>
                                                    <el-input v-model="voyageNo"
                                                              :placeholder="$t('common.pleaseEnter')"
                                                              clearable/>
                                                </div>
                                                <!--航段查询条件-->
                                                <div class="inputName-left">
                                                    <div class="inputName-title-left">
                                                        <span>{{$t('booking.popover.voyageLeg')}}</span>
                                                    </div>
                                                    <el-input v-model="voyageLeg"
                                                              :placeholder="$t('common.pleaseEnter')"
                                                              clearable/>
                                                </div>
                                                <!--VVL关闭按钮-->
                                                <el-button size="small" class="popoverInner"
                                                           icon="el-icon-warning-outline"
                                                           @click="vvlPopoverClose">
                                                    {{closeButton}}
                                                </el-button>
                                            </div>
                                            <!--船名数据查询表格-->
                                            <el-table :data="tablePopoverVVLInfo" style="width:100%;margin-top:5px"
                                                      max-height="300" highlight-current-row
                                                      :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                                                      :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                                                      :empty-text="$t('common.noData')"
                                                      @row-dblclick="vvlPopTableRowDbClick"
                                                      @row-click="vvlPopTableRowClck">
                                                <!--序号-->
                                                <el-table-column min-width="60" type="index"
                                                                 :label="$t('booking.popover.no')"
                                                                 align="center"></el-table-column>
                                                <!--船舶代码-->
                                                <el-table-column min-width="110" prop="vesselCode"
                                                                 :label="$t('booking.popover.vesselCode')"
                                                                 align="center"></el-table-column>
                                                <!--船名-->
                                                <el-table-column min-width="190" prop="vesselName"
                                                                 :label="$t('booking.popover.vessel')"
                                                                 align="center"></el-table-column>
                                                <!--船中文名-->
                                                <el-table-column min-width="140" prop="vesselNameCn"
                                                                 :label="$t('booking.popover.vesselNameCN')"
                                                                 align="center"></el-table-column>
                                                <!--航次-->
                                                <el-table-column min-width="100" prop="voyageNo"
                                                                 :label="$t('booking.popover.voyageNo')"
                                                                 align="center"></el-table-column>
                                                <!--航段-->
                                                <el-table-column min-width="110" prop="voyageLeg"
                                                                 :label="$t('booking.popover.voyageLeg')"
                                                                 align="center"></el-table-column>
                                            </el-table>
                                            <div class="flex flex-space-between">
                                                <div class="topMargin flex1">
                                                    {{this.$t("common.total").replace("?", this.popTotal)}}
                                                </div>
                                                <!--VVL确认按钮-->
                                                <el-button class="topMargin" type="primary"
                                                           @click="vvlPopoverConfirm">
                                                    {{confirmButton}}
                                                </el-button>
                                                <!--VVL pagination分页条-->
                                                <div class="pagination flex1">
                                                    <el-pagination small layout="sizes,pager"
                                                                   :page-size="popPageSize" :page-sizes="[5, 10]"
                                                                   :total="popTotal"
                                                                   :pager-count="popPageCount"
                                                                   :current-page="popPageNum"
                                                                   @size-change="popVVLHandleSizeChange"
                                                                   @current-change="popVVLHandleCurrentChange"
                                                                   max-height="600"></el-pagination>
                                                </div>
                                            </div>
                                        </div>
                                        <img slot="reference" style="cursor:pointer" class="voyageIcon"
                                             src="../../../assets/image/voyage.png"/>
                                    </el-popover>
                                </el-col>
                            </div>
                            <!--年/月-->
                            <div class="inputName">
                                <!--年份-->
                                <el-col :span="7" style="width: 65%">
                                    <div class="inputName">
                                        <span class="inputName-title">{{$t("confirmFreight.year")}}</span>
                                        <el-select v-model="search.year" :placeholder="$t('common.pleaseSelect')"
                                                   clearable>
                                            <el-option v-for="item in yearOptions"
                                                       :key="item.label" :label="item.label" :value="item.value">
                                                <span style="float: left">{{item.label}}</span>
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                                <!--结算月-->
                                <el-col :span="7" style="width: 35%">
                                    <div class="inputName">
                                        <span class="inputName-title">{{$t("confirmFreight.settleMonth")}}</span>
                                        <el-select v-model="search.month" :placeholder="$t('common.pleaseSelect')"
                                                   clearable>
                                            <el-option
                                                    v-for="item in monthOptions"
                                                    :key="item.value" :label="item.label" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                            </div>
                            <!--开航时间从-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("confirmFreight.sailingTimeStart")}}</span>
                                <el-date-picker
                                        v-model="search.sailingTimeStart"
                                        align="right"
                                        type="date"
                                        :placeholder="$t('common.pleaseSelectDate')">
                                </el-date-picker>
                            </div>
                            <!--开航时间到-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("confirmFreight.sailingTimeEnd")}}</span>
                                <el-date-picker
                                        v-model="search.sailingTimeEnd"
                                        align="right"
                                        type="date"
                                        :placeholder="$t('common.pleaseSelectDate')">
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="flex flex-space-around topMargin">
                            <!--提单号-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("confirmFreight.blNo")}}</span>
                                <el-input v-model="blNo" :placeholder="$t('common.multiBlNoEnter')" type="textarea"
                                          maxlength="2000" show-word-limit>
                                    <el-button slot="append" icon="el-icon-search"></el-button>
                                </el-input>
                            </div>
                            <div class="inputName">
                                <!--费项-->
                                <el-col :span="7" style="width: 65%">
                                    <el-col :span="7" style="width: 90%">
                                        <div class="inputName">
                                        <span class="inputName-title">{{$t("confirmFreight.charge")}}</span>
                                            <el-input v-model="chargeCode"
                                                      :placeholder="$t('common.pleaseEnter')"
                                                      clearable/>
                                        </div>
                                    </el-col>
                                    <el-col :span="7" style="width: 10%; margin-left:-3px">
                                        <!--费用查询弹框-->
                                        <el-popover ref="chargeCodePopover" class="popover" width="600" trigger="click"
                                                    placement="right"
                                                    @show="initChargePopoverSearchData"
                                                    @hide="chargeCodeShow=false">
                                            <el-row>
                                                <el-col :span="7" style="width: 49%; margin-left: 5px">
                                                    <!--费用代码查询条件-->
                                                    <div class="inputName-left">
                                                        <div class="inputName-title-left">
                                                            <span>{{$t("confirmFreight.chargeCode")}}</span>
                                                        </div>
                                                        <el-input v-model="chargePopoverSearch.chargeCode"
                                                                  :placeholder="$t('common.pleaseEnter')"
                                                                  clearable/>
                                                    </div>
                                                </el-col>
                                                <el-col :span="7" style="width: 49%; margin-left: 5px">
                                                    <!--费用名称查询条件-->
                                                    <div class="inputName-left">
                                                        <div class="inputName-title-left">
                                                            <span>{{$t("confirmFreight.chargeName")}}</span>
                                                        </div>
                                                        <el-input v-model="chargePopoverSearch.chargeName"
                                                                  :placeholder="$t('common.pleaseEnter')"
                                                                  clearable/>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                            <el-row style="margin-top: 5px">
                                                <el-col :span="7" style="width: 49%; margin-left: 5px">
                                                    <!--费用名称CN查询条件-->
                                                    <div class="inputName-left">
                                                        <div class="inputName-title-left">
                                                            <span>{{$t("confirmFreight.chargeNameCn")}}</span>
                                                        </div>
                                                        <el-input v-model="chargePopoverSearch.chargeNameCn"
                                                                  :placeholder="$t('common.pleaseEnter')"
                                                                  clearable/>
                                                    </div>
                                                </el-col>
                                                <el-col :span="7"
                                                        style="width: 49%; margin-left: 5px; text-align: right">
                                                    <el-button class="popoverInner" size="small" icon="el-icon-search"
                                                               @click="chargeCodePopoverSearch">
                                                        {{findButton}}
                                                    </el-button>
                                                    <el-button class="popoverInner" size="small"
                                                               icon="el-icon-warning-outline"
                                                               @click="closeChargeCodePopoverView">
                                                        {{closeButton}}
                                                    </el-button>
                                                </el-col>
                                            </el-row>
                                            <!--费用代码数据表格-->
                                            <el-table :data="tablePopoverChargeInfo" class="chargeCodePopover"
                                                      style="width:100%;margin-top:5px;margin-bottom: 5px"
                                                      max-height="350" highlight-current-row
                                                      :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                                                      :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                                                      :empty-text="$t('common.noData')"
                                                      @row-dblclick="chargePopTableRowDbClick"
                                                      @row-click="chargePopTableRowClick">
                                                <el-table-column width="60" type="index" :label="this.$t('confirmFreight.no')"></el-table-column>
                                                <el-table-column width="100" prop="chargeCode"
                                                                 :label="this.$t('confirmFreight.chargeCode')"></el-table-column>
                                                <el-table-column width="230" prop="chargeName"
                                                                 :label="this.$t('confirmFreight.chargeName')"></el-table-column>
                                                <el-table-column width="230" prop="chargeNameCn"
                                                                 :label="this.$t('confirmFreight.chargeNameCn')"></el-table-column>
                                            </el-table>
                                            <div class="flex flex-space-between">
                                                <div class="topMargin flex1">
                                                    {{this.$t("common.total").replace("?", this.popTotal)}}
                                                </div>
                                                <el-button class="popoverInner" type="primary"
                                                           @click="chargeCodePopoverConfirm">
                                                    {{confirmButton}}
                                                </el-button>
                                                <div class="pagination flex1">
                                                    <el-pagination max-height="600" small layout="sizes,pager"
                                                                   :page-size="chargePopoverSearch.popPageSize"
                                                                   :total="chargePopoverSearch.popTotal"
                                                                   :page-sizes="[10, 20, 30, 40, 50]"
                                                                   :pager-count="chargePopoverSearch.popPageCount"
                                                                   :current-page="chargePopoverSearch.popPageNum"
                                                                   @size-change="popVVLHandleSizeChange"
                                                                   @current-change="popVVLHandleCurrentChange">
                                                    </el-pagination>
                                                </div>
                                            </div>
                                            <!--费用查询弹框显示按钮-->
                                            <img slot="reference" style="cursor:pointer" class="chargeCodeButton"
                                                 src="../../../assets/image/selectMore.png"/>
                                        </el-popover>
                                    </el-col>
                                </el-col>
                                <el-col :span="7" style="width: 35%">
                                    <!--币种-->
                                    <div class="inputName">
                                        <span class="inputName-title">
                                            {{$t('confirmFreight.currency')}}
                                        </span>
                                        <el-select v-model="search.currency" clearable
                                                   :placeholder="$t('common.pleaseSelect')"
                                                   @focus="currencyCodeFocus">
                                            <el-option
                                                    v-for="item in currencyOptions"
                                                    :key="item.currencyCode"
                                                    :label="item.currencyCode"
                                                    :value="item.currencyCode">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                            </div>
                            <!--是否对账-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("confirmFreight.isReconciliated")}}</span>
                                <el-select v-model="search.isReconciliated"
                                           placeholder=""
                                           clearable>
                                    <el-option v-for="item in reconciliationOptions"
                                               :key="item.codeValue" :label="getDisplayValue(item)"
                                               :value="item.codeValue">
                                        <span style="float: left">{{item.displayValueCn}}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValue}}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="searchBtn">
                                <!--查询按钮-->
                                <el-button type="primary" icon="el-icon-search"
                                           @click="searchBtnClick">
                                    {{searchButton}}
                                </el-button>
                                <!--重置按钮-->
                                <el-button icon="el-icon-refresh"
                                           @click="resetBtnClick">
                                    {{resetButton}}
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <!--查询结果-->
            <div class="contentListCom">
                <result-bar>
                    <div slot="resultRight">
<!--                        &lt;!&ndash;全选&ndash;&gt;-->
<!--                        <el-button icon="el-icon-my-selectAll" @click="checkAllBtnClick(true)">-->
<!--                            {{selectAll}}-->
<!--                        </el-button>-->
<!--                        &lt;!&ndash;反选&ndash;&gt;-->
<!--                        <el-button icon="el-icon-my-selectInverse" @click="checkAllBtnClick(false)">-->
<!--                            {{selectInverse}}-->
<!--                        </el-button>-->
                        <!--生成对账单-->
                        <el-button icon="el-icon-s-order" @click="billGenerateBtnClick()" :disabled="getGenerateBtnStatus">
                            {{billGenerate}}
                        </el-button>
                    </div>
                </result-bar>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="this.$t('confirmFreight.voyageInfo')" name="first">
                        <div v-show="showNoDataView || tableVoyageInfo.length === 0" class="noData">
                            <no-data-view/>
                        </div>
                        <div v-show="!showNoDataView && tableVoyageInfo.length > 0">
                            <vxe-table show-overflow ref="tableVoyageInfo" class="vxeTable"
                                       :align="allAlign" size="small"
                                       max-height="500"
                                       :row-config="{isCurrent: true, isHover: true}"
                                       :column-config="{resizable: true}"
                                       :data="tableVoyageInfo"
                                       :print-config="{}"
                                       :checkbox-config="{checkStrictly: true}"
                                       @checkbox-change="handleVoyageInfoChecked">
<!--                                <vxe-column type="checkbox" width="40"></vxe-column>-->
                                <vxe-column type="seq" width="60" title="confirmFreight.no"></vxe-column>
                                <vxe-column field="voyageYear" width="60" title="confirmFreight.year"></vxe-column>
                                <vxe-column field="voyageMonth" width="80" title="confirmFreight.settleMonth"></vxe-column>
                                <vxe-column field="vesselCode" width="100" title="confirmFreight.vesselCode"></vxe-column>
                                <vxe-column field="vesselName" width="220" title="confirmFreight.vesselName"></vxe-column>
                                <vxe-column field="voyageNo" width="100" title="confirmFreight.voyageNo"></vxe-column>
                                <vxe-column field="voyageLeg" width="100" title="confirmFreight.voyageLeg"></vxe-column>
                                <vxe-column field="saillingDate" width="120" title="confirmFreight.saillingDate"></vxe-column>
                                <vxe-column field="amountTotal" title="confirmFreight.amountTotal"></vxe-column>
                            </vxe-table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="this.$t('confirmFreight.freightInfo')" name="second">
                        <div v-show="showNoDataView || tableFreightInfo.length === 0" class="noData">
                            <no-data-view/>
                        </div>
                        <div v-show="!showNoDataView && tableFreightInfo.length > 0">
                            <vxe-table show-overflow ref="tableFreightInfo" class="vxeTable"
                                       max-height="500" size="small"
                                       :row-config="{isCurrent: true, isHover: true}"
                                       :column-config="{resizable: true}"
                                       :export-config="{}"
                                       :print-config="{}"
                                       :align="allAlign"
                                       :data="tableFreightInfo"
                                       :checkbox-config="{checkStrictly: true}"
                                       @checkbox-change="handleFreightInfoChecked">
<!--                                <vxe-column type="checkbox" width="40"></vxe-column>-->
                                <!--序号-->
<!--                                <vxe-column type="seq" width="60" :title="this.$t('confirmFreight.no')"></vxe-column>-->
                                <vxe-column field="rowNo" width="60" title="confirmFreight.no"></vxe-column>
                                <!--船舶-->
                                <vxe-column field="vesselName" width="220" title="confirmFreight.vesselName" sortable></vxe-column>
                                <!--船舶代码-->
                                <vxe-column field="vesselCode" width="120" title="confirmFreight.vesselCode" sortable></vxe-column>
                                <!--航次-->
                                <vxe-column field="voyageNo" width="120" title="confirmFreight.voyageNo" sortable></vxe-column>
                                <!--航段-->
                                <vxe-column field="voyageLeg" width="120" title="confirmFreight.voyageLeg" sortable></vxe-column>
                                <!--开航时间-->
                                <vxe-column field="saillingDate" width="130" title="confirmFreight.saillingDate" sortable></vxe-column>
                                <!--提单号-->
                                <vxe-column field="blNo" width="180" title="confirmFreight.blNo" sortable>
                                    <template #header>
                                        <i :class="collapsableVesselInfo ? 'vxe-icon-square-minus' : 'vxe-icon-square-plus'" @click="collapsableVesselInfoEvent"></i>
                                        <span>{{blNoField}}</span>
                                    </template>
                                </vxe-column>
                                <!--费项代码-->
                                <vxe-column field="chargeCode" width="130" title="confirmFreight.chargeCode" sortable></vxe-column>
                                <!--费项名称-->
                                <vxe-column field="chargeName" width="150" title="confirmFreight.chargeNameCn">
                                    <template slot-scope="scope">
                                        <span>{{getChargeNameDisplayValue(scope.row)}}</span>
                                    </template>
                                </vxe-column>
                                <!--计价数量-->
                                <vxe-column field="caculateQty" width="130" title="confirmFreight.caculateQty" sortable></vxe-column>
                                <!--计价单位-->
                                <vxe-column field="caculateUnit" width="120" title="confirmFreight.caculateUnit"></vxe-column>
                                <!--币种-->
                                <vxe-column field="currency" width="100" title="confirmFreight.currency" sortable></vxe-column>
                                <!--应收金额-->
                                <vxe-column field="amount" width="120" title="confirmFreight.amount" sortable></vxe-column>
<!--                                &lt;!&ndash;应收客户代码&ndash;&gt;-->
<!--                                <vxe-column field="payer" width="150" title="confirmFreight.payer"></vxe-column>-->
                                <!--应收客户名称-->
                                <vxe-column field="customerName" width="220" title="confirmFreight.customerName">
                                    <template slot-scope="scope">
                                        <span>{{getCustomerNameDisplayValue(scope.row)}}</span>
                                    </template>
                                </vxe-column>
<!--                                &lt;!&ndash;应收客户名称(CN)&ndash;&gt;-->
<!--                                <vxe-column field="customerNameCn" width="220" title="confirmFreight.customerNameCn"></vxe-column>-->
<!--                                &lt;!&ndash;付费方式&ndash;&gt;-->
<!--                                <vxe-column field="payModel" width="100" title="confirmFreight.payModel"></vxe-column>-->
                            </vxe-table>
                            <div class="cardTitle flex flex-space-between">
                                <vxe-toolbar>
                                    <template #buttons>
                                        <vxe-button @click="exportDataEvent" status="primary" icon="vxe-icon-file-txt">{{$t("confirmFreight.button.exportTableDataBtn")}}</vxe-button>
                                    </template>
                                </vxe-toolbar>
                                <vxe-pager
                                        :loading="tableFreightPage.loading1"
                                        :current-page="tableFreightPage.currentPage"
                                        :page-size="tableFreightPage.pageSize"
                                        :total="tableFreightPage.totalResult"
                                        :page-sizes="tableFreightPage.pageSizes"
                                        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                                        @page-change="handleVoyageInfoPageChange">
                                </vxe-pager>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>

        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>

<script>
    import noDataView from "@/components/noDataView";
    import resultBar from "@/components/resultBar";

    export default {
        name: "confirmFreight",
        computed: {
            // 船名航次查询条件
            vesselCode: {
                get: function () {
                    return this.search.vesselCode;
                },
                set: function (val) {
                    this.search.vesselCode = val.toUpperCase();
                }
            },
            vesselName: {
                get: function () {
                    return this.search.vesselName;
                },
                set: function (val) {
                    this.search.vesselName = val.toUpperCase();
                }
            },
            voyageNo: {
                get: function () {
                    return this.search.voyageNo;
                },
                set: function (val) {
                    this.search.voyageNo = val.toUpperCase();
                }
            },
            voyageLeg: {
                get: function () {
                    return this.search.voyageLeg;
                },
                set: function (val) {
                    this.search.voyageLeg = val.toUpperCase();
                }
            },
            // 提单号查询条件
            blNo: {
                get: function () {
                    return this.search.blNo;
                },
                set: function (val) {
                    this.search.blNo = val.toUpperCase();
                }
            },
            // 费项查询条件
            chargeCode: {
                get: function () {
                    return this.search.chargeCode;
                },
                set: function (val) {
                    this.search.chargeCode = val.toUpperCase();
                }
            },
            searchButton() {//查询按钮
                return this.$t("common.searchButton");
            },
            resetButton() {//重置按钮
                return this.$t("common.resetButton");
            },
            findButton() {//搜索按钮
                return this.$t("common.findButton");
            },
            closeButton() {//关闭按钮
                return this.$t("common.closeButton");
            },
            confirmButton() {//确认按钮
                return this.$t("common.confirmButton");
            },
            selectAll() {//全选
                return this.$t("common.selectAll");
            },
            selectInverse() {//反选
                return this.$t("common.selectInverse");
            },
            billGenerate() {//生成对账单
                return this.$t('confirmFreight.button.billGenerateBtn');
            },
            blNoField() {
                return this.$t('confirmFreight.blNo');
            },
            getGenerateBtnStatus(){
                if(this.tableFreightInfo.length > 0){
                    let isReconciliated = false;
                    this.tableFreightInfo.forEach((item)=>{
                        // 校验是否有已经对账的费用
                        if(item.isReconciliated == 1){
                            isReconciliated = true;
                        }
                    });
                    return isReconciliated;
                } else {
                    return true;
                }
            },
        },
        components: {
            noDataView,
            resultBar,
        },
        data() {
            return {
                activeName: 'first',// 默认选中第一个tab页
                allAlign: 'center',// vxe-table表格默认文字居中

                isSearchClick: false,       //控制查询按钮是否重复点击
                boatListShow: false,        //控制船舶查询弹框是否显示
                chargeCodeShow: false,      //控制费项查询弹框是否显示
                showNoDataView: true,
                collapsableVesselInfo: true,

                yearOptions: [],               //年份下拉选
                monthOptions: [],              //月份下拉选
                currencyOptions: [],
                reconciliationOptions: [
                    {codeValue: 0, displayValueCn: "未对账", displayValue: "UNRECONCILED"},
                    {codeValue: 1, displayValueCn: "已对账", displayValue: "RECONCILED"},
                ],

                //查询参数
                search: {
                    vesselCode: "",         //船舶代码
                    vesselName: "",         //船名
                    voyageNo: "",           //航次
                    voyageLeg: "",         //航段
                    sailingTimeStart: "",   //开航时间从
                    sailingTimeEnd: "",     //开航时间到
                    blNo: "",               //提单号
                    year: "",               //年份
                    month: "",              //月份
                    chargeCode: "",         //费项
                    currency: "",           //币种
                    isReconciliated: 0      //是否对账
                },
                //费用弹框查询参数
                chargePopoverSearch: {
                    chargeCode: "",
                    chargeName: "",
                    chargeNameCn: "",
                    popTableSelection: [],
                    popTotal: 0,
                    popPageCount: 5,
                    popPageNum: 1,
                    popPageSize: 50,
                },
                // 船名/航次弹框分页参数
                popPageCount: 5,
                popPageNum: 1,
                popPageSize: 5,
                popTotal: 0,
                // 航次信息表格分页参数
                tableFreightPage: {
                    loading1: false,
                    currentPage: 1,
                    pageSize: 1000,
                    pageSizes: [1000, 2000, 5000, 10000],
                    layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
                    totalResult: 0
                },

                // 【航次数据】
                tableVoyageInfo: [],
                tableVoyageInfoChecked: [], //航次信息表格多选列表
                // 【费用数据】
                tableFreightInfo: [],
                tableFreightInfoChecked: [],//费用信息表格多选列表
                // 船名航次弹框 【船名航次数据】
                boatList: [],
                tablePopoverVVLInfo: [],
                tablePopoverVVLSelection: [],   //船名航次弹框中表格当前点击选中数据
                //费用查询弹框 【费用代码数据】
                tablePopoverChargeInfo: [],
                tablePopoverChargeSelection: [], //费用弹框中表格当前点击选中数据
            }
        },
        methods: {
            /************************************ 工具栏按钮点击事件 *************************************/
            /**
             * 费用查询按钮点击
             */
            searchBtnClick() {
                if (this.isSearchClick) {// 控制查询点击频率
                    return;
                }
                this.isSearchClick = true;

                // 查询条件校验
                if(!this.validateSearch()){
                    this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
                    return;
                }

                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.searching'),             // 加载动画的文字
                    spinner: 'el-icon-loading',                     // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                    target: document.querySelector(".searchList")   // 设置加载动画区域
                });
                let that = this.loadingtuo;

                this.axios({
                    method: 'post',
                    url: '/api/booking/freightsReceivableQuery',
                    data: {
                        vesselCode: this.search.vesselCode,
                        voyageNo: this.search.voyageNo,
                        voyageLeg: this.search.voyageLeg,
                        voyageYear: this.search.year,
                        voyageMonth: this.search.month,
                        saillingDateFrom: this.search.sailingTimeStart === "" ? "" : this.formatDate(
                            {date: this.search.sailingTimeStart, formatStr: 'yyyy-MM-dd'}
                        ),
                        saillingDateTo: this.search.sailingTimeEnd === "" ? "" : this.formatDate(
                            {date: this.search.sailingTimeEnd, formatStr: 'yyyy-MM-dd'}
                        ),
                        blNo: this.search.blNo,
                        chargeCode: this.search.chargeCode,
                        currency: this.search.currency,
                        isReconciliated: this.search.isReconciliated,
                        pageNum: this.tableFreightPage.currentPage,
                        pageSize: this.tableFreightPage.pageSize
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        // 隐藏无数据组件
                        this.showNoDataView = false;
                        // 赋值费用信息
                        if(response.data.object != null && response.data.object[0] != null){
                            this.tableFreightInfo = response.data.object[0];
                        }
                        if(response.data.object != null && response.data.object[2] != null){
                            this.tableFreightPage.totalResult = response.data.object[2];
                        }
                        // 赋值航次信息
                        if(response.data.object != null && response.data.object[1] != null){
                            this.tableVoyageInfo = response.data.object[1];
                        }
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                        if (response.data.backCode === "207"){
                            // 当前未登录，跳转到登录页面
                            this.$router.push({
                                path: '/homePage',
                                query: {redirect: "/confirmFreight"} // 将跳转的路由path作为参数，登录成功后跳转到该路由
                            });
                        }
                    }
                    this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
                    that.close();
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                    this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
                    that.close();
                });
            },
            /**
             * 查询条件校验
             */
            validateSearch(){
                // 船名航次与年份月份不能同时为空
                let vvlIsNullFlag = !(this.search.vesselCode || this.search.voyageNo || this.search.voyageLeg);
                let ymIsNullFlag = !(this.search.year || this.search.month);
                if(vvlIsNullFlag && ymIsNullFlag){
                    this.showMessage(false, this.$t("confirmFreight.message.searchValidate"), "warning");
                    return false;
                }
                // 校验提单号查询条件长度是否超过2000
                if(this.search.blNo != null && this.search.blNo.length > 2000){
                    this.showMessage(false, this.$t("confirmFreight.message.searchblNoValidate",{length: 2000}), "warning");
                    return false;
                }
                return true;
            },
            /**
             * 重置按钮点击
             */
            resetBtnClick() {
                this.search.vesselCode = "";         //船舶代码
                this.search.vesselName = "";         //船名
                this.search.voyageNo = "";           //航次
                this.search.voyageLeg = "";         //航段
                this.search.sailingTimeStart = "";   //开航时间从
                this.search.sailingTimeEnd = "";     //开航时间到
                this.search.blNo = "";               //提单号
                this.search.year = "";               //年份
                this.search.month = "";              //月份
                this.search.chargeCode = "";         //费项
                this.search.currency = "";           //币种
                this.search.isReconciliated = 0;      //是否对账
            },
            /**
             * 全选/反选
             */
            checkAllBtnClick(isCheck) {
                console.log(isCheck);
                // 清空表格选中列表
                this.tableVoyageInfoChecked = [];
                this.tableFreightInfoChecked = [];

                if(isCheck){
                    // 航次信息全选
                    this.tableVoyageInfo.forEach((item,index)=>{
                        this.$refs.tableVoyageInfo.setCheckboxRow(this.tableVoyageInfo[index], true);
                    });
                    // 费用信息全选
                    this.tableFreightInfo.forEach((item,index)=>{
                        this.$refs.tableFreightInfo.setCheckboxRow(this.tableFreightInfo[index], true);
                    });
                }else{
                    // 航次信息反选
                    this.tableVoyageInfo.forEach((item,index)=>{
                        this.$refs.tableVoyageInfo.toggleCheckboxRow(this.tableVoyageInfo[index]);
                    });
                    // 费用信息反选
                    this.tableFreightInfo.forEach((item,index)=>{
                        this.$refs.tableFreightInfo.toggleCheckboxRow(this.tableFreightInfo[index]);
                    })
                }

                // 赋值表格选中记录
                this.tableVoyageInfoChecked = this.$refs.tableVoyageInfo.getCheckboxRecords();
                this.tableFreightInfoChecked = this.$refs.tableFreightInfo.getCheckboxRecords();
            },
            tableVoyageCheckOneMethod(index, type) {
                let curData = this.tableVoyageInfo[index];
                if (type) {//选中
                    this.tableVoyageInfoChecked.push(curData);
                    this.$refs.tableVoyageInfo.setCheckboxRow(this.tableVoyageInfo[index], true);
                } else {//取消选中
                    let checkBkFreightReceiveId = this.tableVoyageInfo[index].bkFreightReceiveId;
                    this.tableVoyageInfoChecked.forEach((item, index) => {
                        if (item.bkFreightReceiveId === checkBkFreightReceiveId) {
                            // 将当前行从选中费用中移除
                            this.tableVoyageInfoChecked.splice(index, 1);
                        }
                    });
                    this.$refs.tableVoyageInfo.toggleCheckboxRow(this.tableVoyageInfo[index]);
                }
            },
            tableFreightCheckOneMethod(index, type) {
                if (type) {//选中
                    this.tableFreightInfoChecked.push(this.tableFreightInfo[index]);
                    this.$refs.tableFreightInfo.setCheckboxRow(this.tableFreightInfo[index], true);
                } else {//取消选中
                    let checkBkFreightReceiveId = this.tableFreightInfo[index].bkFreightReceiveId;
                    this.tableFreightInfoChecked.forEach((item, index) => {
                        if (item.bkFreightReceiveId === checkBkFreightReceiveId) {
                            // 将当前行从选中费用中移除
                            this.tableFreightInfoChecked.splice(index, 1);
                        }
                    });
                    this.$refs.tableFreightInfo.toggleCheckboxRow(this.tableFreightInfo[index]);
                }
            },
            tableFreightCancelCheckedMethod(index) {
                let curData = this.tableFreightInfo[index];
                this.tableFreightInfoChecked.forEach((item, index) => {
                    if (item.bkFreightReceiveId === curData.bkFreightReceiveId) {
                        this.tableFreightInfoChecked.splice(index, 1);
                    }
                });
                this.$refs.tableFreightInfo.setCheckboxRow(this.tableFreightInfo[index], false)
            },
            /**
             * 生成对账单按钮点击事件
             */
            billGenerateBtnClick() {
                // // 校验是否有勾选费用明细，未勾选费用明细不能生成对账单
                // if(this.tableFreightInfoChecked.length <= 0){
                //     this.showMessage(false, this.$t("confirmFreight.message.billGenerateValidate"), "warning");
                //     return;
                // }

                if(this.tableFreightInfo.length > 0){
                    // 校验勾选的费用是否全部未对账
                    let isAllAllowed = true;


                    if(!isAllAllowed){
                        this.showMessage(false, this.$t("confirmFreight.message.freightStatusValidate"), "warning");
                        return;
                    }

                    // 获取当前登录用户信息
                    let customer = JSON.parse(sessionStorage.getItem("CUSTOMER"));
                    let statementOfAccountInfo = {};
                    statementOfAccountInfo.balanceUnits = customer.companyCode;
                    statementOfAccountInfo.balanceUnitsEn = customer.companyName;
                    statementOfAccountInfo.balanceUnitsCn = customer.companyNameCn;
                    statementOfAccountInfo.confirmStatus = 0;//未确认
                    statementOfAccountInfo.invoiceStatus = 0;//未开票
                    statementOfAccountInfo.soaDetails = [];
                    // this.$router.push({
                    //     name: 'billsDetails',
                    //     params: {
                    //         statementOfAccountInfo: statementOfAccountInfo,
                    //         freightReceiveVos: this.tableFreightInfoChecked
                    //     }
                    // });
                    var route = this.$router.resolve({
                        name: 'billsDetails',
                    });
                    // 将传递参数存到session中
                    sessionStorage.setItem("PASSING_PARAMETERS", JSON.stringify(statementOfAccountInfo));
                    // sessionStorage.setItem("PASSING_PARAMETERS_1", JSON.stringify(this.tableFreightInfoChecked));
                    sessionStorage.setItem("PASSING_PARAMETERS_1", JSON.stringify(this.tableFreightInfo));
                    // 打开对账单明细页面
                    window.open(route.href, '_blank')
                }
            },

            handleVoyageInfoPageChange ({ currentPage, pageSize }) {
                this.tableFreightPage.currentPage = currentPage;
                this.tableFreightPage.pageSize = pageSize;
                this.searchBtnClick();
            },

            /************************************ 表格多选事件 *************************************/
            handleVoyageInfoChecked({checked}) {
                const records = this.$refs.tableVoyageInfo.getCheckboxRecords();
                // 更新表格勾选的费用信息
                this.tableVoyageInfoChecked = records;
                let vvlMap = new Map();
                this.tableVoyageInfoChecked.forEach((item) => {
                    vvlMap.set(item.vesselCode + item.voyageNo + item.voyageLeg, 1)
                });
                // 遍历费用信息表格，将属于该航次下的全部费用都自动勾选上
                let vvlList = [];
                for (let item of vvlMap.keys()) {
                    vvlList.push(item);
                }
                this.tableFreightInfo.forEach((freight, index) => {
                    if (vvlList.includes(freight.vesselCode + freight.voyageNo + freight.voyageLeg)) {
                        this.tableFreightCheckOneMethod(index, true);
                    } else {
                        this.tableFreightCancelCheckedMethod(index);
                    }
                })
            },
            /**
             * 费用信息表格勾选事件
             */
            // handleFreightInfoChecked(val) {
            //     // 更新表格勾选的费用信息
            //     this.tableFreightInfoChecked = val;
            // },
            handleFreightInfoChecked({checked}) {
                const records = this.$refs.tableFreightInfo.getCheckboxRecords();
                // 更新表格勾选的费用信息
                this.tableFreightInfoChecked = records;
            },
            /**
             * 获取费用信息表格选中费用记录
             */
            getFreightInfoSelectEvent () {
                let selectRecords = this.$refs.tableFreightInfo.getCheckboxRecords();
                return selectRecords;
            },
            /**
             * 表格数据导出
             */
            exportDataEvent () {
                this.$refs.tableFreightInfo.openExport({ types: ['csv'] })
            },
            collapsableVesselInfoEvent () {
                const fields = ['vesselName', 'vesselCode', 'voyageNo', 'voyageLeg', 'saillingDate'];
                this.collapsableVesselInfo = !this.collapsableVesselInfo;
                const tableFreightInfo = this.$refs.tableFreightInfo;
                fields.forEach(field => {
                    const column = tableFreightInfo.getColumnByField(field);
                    column.visible = this.collapsableVesselInfo
                });
                tableFreightInfo.refreshColumn()
            },

            /************************************ 船名航次弹出框 ************************************/
            /**
             * 船名下拉选赋值
             */
            showVesselList() {
                this.boatListShow = true;
                this.axios({
                    method: 'get',
                    url: '/api/codedict/getVesselList',
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.boatList = response.data.object;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 船名下拉表格数据点击事件
             */
            checkBoatData(boat) {
                this.search.vesselCode = boat.vesselCode;
                this.search.vesselName = boat.vesselName;
                this.boatListShow = false
            },
            /**
             * 搜索按钮点击事件
             */
            vvlPopoverSearch() {
                if (this.isVVLSearchClick) {
                    return;
                }
                this.isVVLSearchClick = true;
                this.axios({
                    method: 'post',
                    url: '/api/voyagePlan/getVVLEntity',
                    data: {
                        voyageNo: this.search.voyageNo,
                        voyageLeg: this.search.voyageLeg,
                        vesselName: this.search.vesselName,
                        vesselCode: this.search.vesselCode,
                        pageNum: this.popPageNum,
                        pageSize: this.popPageSize
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.tablePopoverVVLInfo = response.data.object.list;
                        this.popTotal = response.data.object.total;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    this.isVVLSearchClick = false;
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                    this.isVVLSearchClick = false;
                });
                //每次查询结束清空tablePopoverVVLSelection
                this.tablePopoverVVLSelection = [];
            },
            /**
             * 确认按钮点击事件
             */
            vvlPopoverConfirm() {
                // 赋值选中记录的船名和航次到VVL查询输入框中
                if (this.tablePopoverVVLSelection.length !== 0) {//获取弹框中最后选中的记录
                    this.vvlPopTableRowDbClick(this.tablePopoverVVLSelection[0]);
                }
                // 关闭弹框
                this.$refs.popover.showPopper = false;
                this.resetVVLPopTableData();
            },
            /**
             * 关闭按钮点击事件
             */
            vvlPopoverClose() {
                this.$refs.popover.showPopper = false;
                this.resetVVLPopTableData();
            },
            /**
             * 船名航次弹框数据分页条
             */
            popVVLHandleDemand() {
                this.vvlPopoverSearch();
            },
            popVVLHandleSizeChange(val) {
                this.popPageSize = val;
                this.popVVLHandleDemand();
                this.$emit("backTop");
            },
            popVVLHandleCurrentChange(val) {
                this.popPageNum = val;
                this.popVVLHandleDemand();
                this.$emit("backTop");
            },
            /**
             * 船名航次表格行点击击事件
             */
            vvlPopTableRowClck(row) {
                this.tablePopoverVVLSelection = [row];
            },
            /**
             * 船名航次表格行双击事件（某行被双击时,自动关闭弹框,获取该行船名航次数据,赋值订舱查询页船名航次输入框）
             */
            vvlPopTableRowDbClick(row) {
                this.search.vesselCode = row.vesselCode;
                this.search.voyageNo = row.voyageNo;
                this.search.voyageLeg = row.voyageLeg;
                this.$refs.popover.showPopper = false;
                this.resetVVLPopTableData();
            },
            resetVVLPopTableData() {
                this.tablePopoverVVLInfo = [];
                this.tablePopoverVVLSelection = [];
            },

            /************************************ 费用查询弹出框 ************************************/
            /**
             * 弹框打开初始化事件
             */
            initChargePopoverSearchData(){
                this.chargePopoverSearch = {};
                this.chargePopoverSearch.chargeCode = this.search.chargeCode;
                // 自动调用查询方法
                this.chargeCodePopoverSearch();
            },
            /**
             * 搜索按钮点击事件
             */
            chargeCodePopoverSearch() {
                if (this.isPopSearchClick) {
                    return;
                }
                this.isPopSearchClick = true;
                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.searching'),     //加载动画的文字
                    spinner: 'el-icon-loading',             // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                    target: document.querySelector(".chargeCodePopover") // 设置加载动画区域
                });
                let that = this;
                this.axios({
                    method: 'post',
                    url: '/api/codedict/getChargeCodeList',
                    data: {
                        chargeCode: this.chargePopoverSearch.chargeCode,
                        chargeName: this.chargePopoverSearch.chargeName,
                        chargeNameCn: this.chargePopoverSearch.chargeNameCn,
                        pageNum: this.chargePopoverSearch.popPageNum,
                        pageSize: this.chargePopoverSearch.popPageSize
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    that.loadingtuo.close();
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.tablePopoverChargeInfo = response.data.object.list;
                        this.chargePopoverSearch.popTotal = response.data.object.total;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    this.isPopSearchClick = false;
                }).catch(error => {
                    that.loadingtuo.close();
                    this.isPopSearchClick = false;
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 确认按钮点击事件
             */
            chargeCodePopoverConfirm() {
                // 赋值选中记录的费用代码到费用查询输入框中
                if (this.tablePopoverChargeSelection.length !== 0) {//获取弹框中最后选中的记录
                    this.chargePopTableRowDbClick(this.tablePopoverChargeSelection[0]);
                }
                // 关闭弹框
                this.$refs.chargeCodePopover.showPopper = false;
                this.resetChargePopTableData();
            },
            /**
             * 关闭按钮点击事件
             */
            closeChargeCodePopoverView() {
                this.$refs.chargeCodePopover.showPopper = false;
                this.resetChargePopTableData();
            },
            /**
             * 费用代码表格行点击击事件
             */
            chargePopTableRowClick(row) {
                this.tablePopoverChargeSelection = [row];
            },
            /**
             * 费用代码表格行双击事件（某行被双击时,自动关闭弹框,获取该行费用代码,赋值费用代码查询输入框）
             */
            chargePopTableRowDbClick(row) {
                this.search.chargeCode = row.chargeCode;
                this.$refs.chargeCodePopover.showPopper = false;
                this.resetChargePopTableData();
            },
            resetChargePopTableData() {
                this.tablePopoverChargeInfo = [];
                this.tablePopoverChargeSelection = [];
            },

            /************************************ 页面数据初始化 ************************************/
            /**
             * 年份/结算月自动赋值
             */
            initYears() {
                this.yearOptions = [];
                this.monthOptions = [];
                let nowDate = new Date();
                let curYear = nowDate.getFullYear();
                let curMonth = nowDate.getMonth();
                for (let i = 0; i < 10; i++) {
                    this.yearOptions.push({value: (curYear - i), label: (curYear - i)})
                }
                for (let j = 1; j <= 12; j++) {
                    this.monthOptions.push({value: j, label: j})
                }
                // 初始化年份月份参数
                this.search.year = curYear;
                this.search.month = curMonth + 1;
            },

            /************************************ 基础数据下拉框赋值 ************************************/
            /**
             * 币种下拉选赋值
             */
            currencyCodeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getCurrencyCodeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.currencyOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },

            /************************************ 其他事件 *************************************/
            /**
             * Tab页点击切换事件
             */
            handleClick(tab, event) {
            },
            /**
             * 获取系统当前语言环境
             */
            getCurLanguage() {
                return localStorage.getItem('locale');
            },
            /**
             * 费用信息表格 费项名称国际化显示 公共方法
             */
            getChargeNameDisplayValue(item){
                if(item == null){
                    return '';
                }
                return localStorage.getItem('locale') == 'en' ? item.chargeName : item.chargeNameCn
            },
            /**
             * 费用信息表格 客户名称国际化显示 公共方法
             */
            getCustomerNameDisplayValue(item){
                if(item == null){
                    return '';
                }
                return localStorage.getItem('locale') == 'en' ? item.customerName : item.customerNameCn
            },
            /**
             * 费用信息表格 付费方式显示 公共方法
             */
            getPaidTypeDisplayValue(item){
                if(item == null){
                    return '';
                }
                return item.payModel==0?'PP':'CC';
            },
            getDisplayValue(item) {
                return localStorage.getItem('locale') == 'en' ? item.displayValue : item.displayValueCn;
            },
            /**
             * 费用信息表格虚拟滚动
             */
            mockList (size) {
                return new Promise(resolve => {
                    const list = [];
                    for (let index = 0; index < size; index++) {
                        list.push(this.tableFreightInfo[index])
                    }
                    resolve(list);
                })
            },
            voyageMockList (size) {
                return new Promise(resolve => {
                    const list = [];
                    for (let index = 0; index < size; index++) {
                        list.push(this.tableVoyageInfo[index])
                    }
                    resolve(list);
                })
            }
        },
        mounted() {
            this.$nextTick(() => {
                const $tableFreightInfo = this.$refs.tableFreightInfo;
                this.mockList(10).then(data => {
                    if ($tableFreightInfo) {
                        $tableFreightInfo.loadData(data)
                    }
                });
                const $tableVoyageInfo = this.$refs.tableVoyageInfo;
                this.voyageMockList(10).then(data => {
                    if ($tableVoyageInfo) {
                        $tableVoyageInfo.loadData(data)
                    }
                });
            })
        },
        created() {
            this.$parent.updateHeaderAside();
            this.initYears();
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    @import "../../../assets/scss/base";
    @import "../../../assets/scss/public";

    /*列表展示*/
    .contentListCom {
        min-height: 264px;
    }

    .contentListCom .oneContent {
        width: 100%;
        margin-bottom: 10px;
        margin-top: 5px;
    }

    .contentListCom .top {
        height: 40px;
        border: 1px solid #E8E8E8;
        background: #E9E9E9;
        padding-left: 18px;
        line-height: 40px;
    }

    .contentListCom .center {
        padding: 15px 0 15px 17px;
        border: 1px solid #E8E8E8;
        background: #FFFFFF;
        border-top: none
    }

    .contentListCom .bottom {
        height: 40px;
        border: 1px solid #E8E8E8;
        background: #FFFFFF;
        border-top: none;
        line-height: 40px;
    }

    .contentListCom .listContentLong {
        width: 330px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #606266;
        margin-top: 5px;
    }

    .contentListCom .listContentShort {
        width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #606266;
        margin-top: 5px;
    }

    .contentListCom .listContent {
        width: 250px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #606266;
        margin-top: 5px;
    }

    .contentListCom .listContent .thirdSpan {
        margin-left: 5px;
        display: inline-block
    }

    .contentListCom .center .listContent {
        font-size: 15px;
        height: 20px;
        line-height: 20px;
    }

    .contentListCom .center .listContent .secondSpan {
        color: #031B28;
    }

    .contentListCom .center .shortListContent {
        width: 200px
    }

    .contentListCom .center .longListContent {
        width: 300px
    }

    .contentListCom .listContent.rightMoney {
        text-align: right;
        margin-right: 5px
    }

    /*列表展示的单选和费用明细按钮*/
    .contentListCom .top {
        position: relative
    }

    .contentListCom .top .evaluateBtn {
        margin-left: 10px;
        border-radius: 4px
    }

    .contentListCom .top .feeDetail {
        position: absolute;
        right: 5px;
        top: 5px
    }

    .contentListCom .top .checkOne {
        margin-right: 5px;
        margin-top: 5px
    }

    /*列表展示图标位置*/
    .contentListCom .center {
        position: relative
    }

    .typeImg {
        width: 160px;
        height: 125px;
        position: absolute;
        right: 10px;
        top: 6px;
    }

    .flexDiv {
        display: flex;
        flex-wrap: wrap;
    }

    /*列表展示协议价订单等内容展示*/
    .leftMessage .msg {
        line-height: 39px;
        margin-left: 10px;
        color: #606266;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .xyj {
        width: 72px;
        color: #BC1920 !important;
    }

    .auditMes {
        max-width: 95px;
    }

    .documentValid {
        width: 210px;
        margin-top: 5px;
        font-weight: bold
    }

    .documentValidLong {
        width: 280px;
        margin-top: 5px;
        font-weight: bold
    }

    .flexDiv .normalListButton {
        margin-right: 3px;
    }

    .flexDiv .normalListButton1 {
        margin-right: 3px;
        margin-top: 2px
    }

    .flexDiv .normalListBlueButton {
        margin-right: 3px;
        background: $colorJ;
        color: $colorA;
        border: 1px solid #F6F6F6;
    }

    .flexDiv .normalListRedButton {
        margin-right: 3px;
        background: $colorC;
        color: $colorA;
        border: 1px solid #F6F6F6;
    }

    .hasBack {
        background-color: #567E8D;
        color: #fff
    }

    .hasBack:hover {
        background-color: #354953 !important;
        color: #fff !important;
    }

    /*其他常用*/
    .visCom {
        visibility: hidden
    }

    .overflow {
        overflow: hidden
    }

    .l {
        float: left
    }

    .r {
        float: right
    }

    .flexDiv {
        display: flex;
        flex-wrap: wrap;
    }

    .jdt_nr {
        width: 50%;
        margin: 0 auto;
        z-index: 10001;
        top: 50%;
        margin-top: -31px;
        text-align: center;
        position: absolute;
        margin-left: 25%
    }

    .inputName {
        flex: 1;
        margin: 0 5px;
    }

    //重写el-input样式，只显示下边框
    .inputName ::v-deep.el-input__inner {
        padding: 0 25px;
    }

    //重写el-textarea样式，更改默认高度
    .inputName{
        /deep/.el-textarea__inner{
            line-height: 1;
            display: block;
            resize: vertical;
            padding: 5px 15px;
            box-sizing: border-box;
            width: 100%;
            font-size: inherit;
            color: #606266;
            background-color: #FFFFFF;
            background-image: none;
            border: 1px solid #DCDFE6;
            border-radius: 4px;
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        }
    }

    .topMargin {
        margin-top: 20px;
    }

    .searchBtn {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        margin: 0 5px;
    }

    .voyageIcon {
        margin-left: 10px;
        margin-top: 5px;
        width: 30px;
        height: 30px;
        border: 1px solid #0091ff;
        border-radius: 4px;
    }

    .noData {
        height: 100%;
        margin: 15px 0;
        background-color: #ffffff;
    }

    .searchList {
        margin: 15px 0;
    }

    /deep/ .el-input-group__prepend {
        background-color: #d9e3f0;
    }

    .popoverView {
        padding: 5px;
        background-color: #ffffff;
    }

    .popoverInner {
        margin: 5px;
        margin-top: 0;
    }

    .flex1 {
        flex: 1;
    }

    .boatBox {
        position: relative;

        .boatBox-list-box {
            min-width: 280px;
            position: absolute;
            left: 51px;
            top: 30px;
            background: $colorA;
            padding: 5px 10px;
            z-index: 100;
            border: 1px solid $colorE;
            font-size: $fontC;
            font-weight: 600;

            .boatBox-top {
                width: 100%;
                height: 20px;
                line-height: 20px;
                background: $colorB;
            }

            .left {
                width: 30%;
                margin-right: 4%;
            }

            .right {
                width: 66%;
            }

            ul {
                padding: 0;
                margin: 0;

                li {
                    border-bottom: 1px solid #e7f0fc;
                    padding: 4px 2px;
                }

                li:last-of-type {
                    border: none;
                }

                li:hover {
                    background: rgb(224, 240, 245);
                }
            }
        }
    }

    .el-upload {
        .el-upload-dragger {
            width: 700px;
        }
    }

    .cardTitle {
        margin-bottom: 10px;

        span {
            font-size: $fontC;
            color: $colorF;
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .my-upload-demo ::v-deep .el-upload {
        .el-upload-dragger {
            background-color: #fff;
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            box-sizing: border-box;
            width: 800px;
            height: 180px;
            text-align: center;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
    }

    .show_table {
        position: relative;
        width: 100%;
        overflow: auto;
    }

    /*给el-table滚动条设置宽度和高度*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
        width: 10px; // 横向滚动条
        height: 10px; // 纵向滚动条 必写
    }

    .chargeCodeButton {
        height: 25px;
        margin-top: 5px;
    }

    /*滚动条整体部分*/
    .vxeTable ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    /*滚动条的轨道*/
    .vxeTable ::-webkit-scrollbar-track {
        background-color: #FFFFFF;
    }
    /*滚动条里面的小方块，能向上向下移动*/
    .vxeTable ::-webkit-scrollbar-thumb {
        background-color: #bfbfbf;
        border-radius: 5px;
        border: 1px solid #F1F1F1;
        box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    }
    .vxeTable ::-webkit-scrollbar-thumb:hover {
        background-color: #A8A8A8;
    }
    .vxeTable ::-webkit-scrollbar-thumb:active {
        background-color: #787878;
    }
    /*边角，即两个滚动条的交汇处*/
    .vxeTable ::-webkit-scrollbar-corner {
        background-color: #FFFFFF;
    }
    .vxeTable ::v-deep .vxe-cell--checkbox .is--checked{
        color: #409eff;
    }

</style>
<style lang="scss">
    //全选icon
    .el-icon-my-selectAll {
        background: url('../../../assets/image/icon/selectAll.png') center center no-repeat;
        font-size: 16px;
        background-size: cover;
    }

    .el-icon-my-selectAll:before {
        content: "替";
        font-size: 16px;
        visibility: hidden;
    }

    //反选icon
    .el-icon-my-selectInverse {
        background: url('../../../assets/image/icon/selectInverse.png') center center no-repeat;
        font-size: 16px;
        background-size: cover;
    }

    .el-icon-my-selectInverse:before {
        content: "替";
        font-size: 16px;
        visibility: hidden;
    }

</style>